import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useService } from '../../../services/services';
import css from './index.module.css';
import BarnList from './barn-list';
import Spinner from '../../../components/common/spinner';

export default function Barns() {
  const { t } = useTranslation();
  const { farmId } = useParams<{ farmId: string }>();
  const { barnService } = useService();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const subscription = barnService
      .syncBarns(farmId)
      .subscribe(
        () => {
          setLoading(false);
        },
        () => {
          setLoading(false);
        },
      );

    return () => subscription.unsubscribe();
  }, [barnService, farmId]);

  if (loading) {
    return (
      <div className={css['loading']}>
        <div>{t('Loading')}</div>
        <Spinner visible={true} size="lg" />
      </div>
    );
  } else {
    return <BarnList />;
  }
}
